import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import {Colxx} from './common/CustomBootstrap';
import {Card, CardBody, CardTitle, Row} from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Doughnut from '../components/charts/Doughnut';
import chartsColor from '../constants/chartColors';

class DoughnutChartCard extends PureComponent {
  render() {
    const {data, labels, title} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {title}
              </CardTitle>
              <div className='d-flex flex-column align-items-center justify-content-center' style={{height: 250}}>
                {data ?
                  <Doughnut
                    shadow={true}
                    data={{
                      labels,
                      datasets: [{
                        data,
                        backgroundColor: labels.map((_, index) => chartsColor[`color_${index + 1}`]),
                      }],
                    }}
                  />
                  :
                  <Skeleton circle={true} height={250} width={250} className='mb-4'/>
                }
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(DoughnutChartCard);
